import { render, staticRenderFns } from "./leave-case.vue?vue&type=template&id=702f1c11&scoped=true"
import script from "./leave-case.vue?vue&type=script&lang=ts"
export * from "./leave-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f1c11",
  null
  
)

export default component.exports